module.exports = __webpack_public_path__ + "img/m-bg.d5b18c72.gif";